import { crmRequest } from '../http'
import type { MergeItem, MergeKind, UndoResult } from './types'

/** The merges (newest first) in which `relationId` was the survivor. */
export async function listMerges(kind: MergeKind, relationId: string): Promise<MergeItem[]> {
  const search = new URLSearchParams({ relation: `${kind}:${relationId}` })
  const answer = await crmRequest<{ items: MergeItem[] }>(`/merges?${search.toString()}`)
  return answer.items
}

export function undoMerge(mergeId: string): Promise<UndoResult> {
  return crmRequest(`/merges/${mergeId}/undo`, { method: 'POST' })
}
